import { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import Standings from './pages/Standings';
import StatisticsPage from './pages/StatisticsPage';
import UploadHistory from './pages/UploadHistory';
import AdminSettings from './pages/AdminSettings';
import UserManagement from './pages/UserManagement';
import EmailUploads from './pages/EmailUploads';
import DuplicateReviews from './pages/DuplicateReviews';
import PlayerProfile from './pages/PlayerProfile';
import { Toaster } from './components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios interceptor for auth
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check auth on mount only - no dependencies needed
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`)
        .then(res => {
          setUser(res.data);
        })
        .catch(() => {
          localStorage.removeItem('token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="text-slate-900 font-barlow text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={!user ? <AuthPage setUser={setUser} /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={user ? <Dashboard user={user} /> : <Navigate to="/auth" />} />
          <Route path="/standings" element={user ? <Standings user={user} /> : <Navigate to="/auth" />} />
          <Route path="/history" element={user ? <UploadHistory user={user} /> : <Navigate to="/auth" />} />
          <Route path="/admin" element={user?.is_admin ? <AdminSettings user={user} /> : <Navigate to="/dashboard" />} />
          <Route path="/admin/users" element={user?.is_admin ? <UserManagement user={user} /> : <Navigate to="/dashboard" />} />
          <Route path="/admin/emails" element={user?.is_admin ? <EmailUploads user={user} /> : <Navigate to="/dashboard" />} />
          <Route path="/admin/duplicates" element={user?.is_admin ? <DuplicateReviews user={user} /> : <Navigate to="/dashboard" />} />
          <Route path="/statistics" element={user ? <StatisticsPage user={user} /> : <Navigate to="/auth" />} />
          <Route path="/player/:playerName" element={user ? <PlayerProfile user={user} /> : <Navigate to="/auth" />} />
          <Route path="/" element={<Navigate to={user ? "/dashboard" : "/auth"} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;